import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "required" }
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_17 = { class: "col-lg-8 fv-row" }
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "row mb-6" }
const _hoisted_21 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_22 = { class: "col-lg-8 fv-row" }
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "row mb-6" }
const _hoisted_26 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_27 = { class: "col-lg-8 fv-row" }
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "row mb-6" }
const _hoisted_31 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_32 = { class: "col-lg-8 fv-row" }
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_36 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_37 = { class: "indicator-label" }
const _hoisted_38 = { class: "indicator-progress" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'auctions'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewLocation')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.validationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.translate('organizer')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "organiserId",
                      class: "form-select form-select-solid form-select-lg text-capitalize"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.translate('selectOrganizer')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organizers, (organizer) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: organizer.id,
                            value: organizer.id
                          }, _toDisplayString(organizer.titleEn), 9, _hoisted_12))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_ErrorMessage, { name: "organiserId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.translate('venueAr')), 1),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "venueAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('venueNameArLang')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_ErrorMessage, { name: "venueAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.translate('venueEn')), 1),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "venueEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('venueNameEnLang')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_ErrorMessage, { name: "venueEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.translate('latitude')), 1),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "latitude",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('latitude')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_ErrorMessage, { name: "latitude" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.translate('longitude')), 1),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "longitude",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('longitude')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_ErrorMessage, { name: "longitude" })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_36, [
                  _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_38, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_39
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}